import posthog from "posthog-js"

import { redactTokens } from "@/lib/redact-tokens"

/**
 * Initialize PostHog product analytics (no-op when `VITE_POSTHOG_PROJECT_TOKEN` is unset).
 * CI sets the token only on `main` builds, so staging, PR, and local builds send nothing.
 */
export function initPostHog(): void {
	const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN
	if (!token) {
		return
	}

	posthog.init(token, {
		api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
		defaults: "2026-05-30",
		// Errors belong to Sentry; keep PostHog exception autocapture off even if the project enables it.
		capture_exceptions: false,
		// URLs, referrers, autocapture hrefs, heatmaps, and replay data.
		before_send: (event) => event && redactTokens(event),
	})
}

/** True once `initPostHog` has run with a token; identity calls check it so they no-op otherwise. */
export function isPostHogLoaded(): boolean {
	return posthog.__loaded
}

export { posthog }
